import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/sound/recordRun.png'
import _imports_1 from '@/assets/sound/recordStop.png'
import _imports_2 from '@/assets/aivoice/ico_bofang.svg'
import _imports_3 from '@/assets/aivoice/ico_zanting.svg'


const _hoisted_1 = { class: "pageRecord" }
const _hoisted_2 = { class: "pageTop" }
const _hoisted_3 = { class: "nameRecord" }
const _hoisted_4 = { class: "aiTextBox" }
const _hoisted_5 = { class: "soundBox" }
const _hoisted_6 = { class: "timeBox" }
const _hoisted_7 = { class: "recordBox" }
const _hoisted_8 = { class: "recordBoxTime" }
const _hoisted_9 = ["id"]
const _hoisted_10 = { class: "recordBoxRun" }
const _hoisted_11 = { class: "recordBoxRunInner" }
const _hoisted_12 = { class: "recordBtnBox" }
const _hoisted_13 = {
  key: 2,
  class: "recordBtnOne"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 0,
  class: "dialog-footer"
}

import { timeInfo, timeInfominute, timedataOther } from '@/components/public-method/time-method';
import { ref, onMounted, nextTick} from 'vue'
import { WarningFilled } from "@element-plus/icons-vue";
import { carveTimeScale } from './timeLine.js'
import FetchRequest from "@/api/FetchRequest";
import Auth from "@/api/Auth";
import Recorder from 'js-audio-recorder'
import lamejs from 'lamejs'
import { uploadFile } from "@/components/common/aiVoiceUploud.ts";
import { ElMessage, ElMessageBox, ElSwitch } from "element-plus";
import {
    CircleClose,
    CircleCloseFilled,
} from "@element-plus/icons-vue";
//接口引入
// import roleAivoice from "@/api/aivoice/index.ts";


export default /*@__PURE__*/_defineComponent({
  __name: 'recording',
  props: {
    businessType: String,
    },
  emits: ['closePage','updataRecord','updataListening'],
  setup(__props, { expose: __expose, emit: __emit }) {

// 时间处理方法
const props = __props
const recorder = new Recorder({
    sampleBits: 8,                 // 采样位数，支持 8 或 16，默认是16
    sampleRate: 48000,              // 采样率，支持 11025、16000、22050、24000、44100、48000，根据浏览器默认值，我的chrome是48000
    numChannels: 1,                 // 声道，支持 1 或 2， 默认是1
    // compiling: false,(0.x版本中生效,1.x增加中)  // 是否边录边转换，默认是false
})

// 开始录音
const startRecorder = () => {
    recorder.start().then((res) => {
        console.log(res)
        reTimeSetval = setInterval(() => {
            // 387
            reTimeStar.value += 100
            runTime.value = reTimeStar.value
            if (lineToLeft.value <= 387) {
                lineStyle.value[lineIndex.value].backgroundColor = '#17B067'
                lineToLeft.value += 6
                lineIndex.value += 1
            } else {
                // lineStyle.value.push(lineStyle.value.shift())
                lineStyle.value.push(lineStyle.value.shift())
                lineStyle.value[lineIndex.value - 1].backgroundColor = '#17B067'
                lineStyle.value[lineStyle.value.length - 1].backgroundColor = '#585F66'
                // carveTimeScale(750, 1, 60, reTimeStar.value, 2, 'time_line')
                timeBoxLeft.value -= 6
                // console.log(lineStyle.shift())
            }
        }, 100)
        startRecordShow.value = false
    }, (error) => {
        // 出错了
        ElMessage({
            type: 'error',
            message: '不存在录音设备，或者被禁用--' + error.message,
        })
        console.log(`${error.name} : ${error.message}`);
    });
}
// 结束录音
const stopRecorder = () => {
   
    if(props.businessType=='cloneVoice'&& reTimeStar.value<3000){
        return
    }
    recorder.stop()
    startRecordShow.value = true
    playOnoff.value = true
    lineStyle.value = initLine
    lineToLeft.value = 0
    lineStyle.value.forEach(item => {
        item.backgroundColor = '#585F66'
    })
    timeBoxLeft.value = 0
    lineIndex.value = 0
    reTimeStar.value = 0
    // 清除定时器
    clearInterval(reTimeSetval)
    reTimeSetval = null
    // this.drawRecordId && cancelAnimationFrame(this.drawRecordId);
    // this.drawRecordId = null;
    getRecorder()
}

/**
     *  获取录音文件
     * */
const titleName=ref('')
const getRecorder = () => {
    let toltime = recorder.duration;//录音总时长
    let fileSize = recorder.fileSize;//录音总大小

    //录音结束，获取取录音数据
    let PCMBlob = recorder.getPCMBlob();//获取 PCM 数据
    let wav = recorder.getWAVBlob();//获取 WAV 数据
    let time = timedataOther(Date.now())
    fileData.value = new File([wav], 'RECORD-' + time + '.wav');
    console.log(fileData.value)
    titleName.value=fileData.value.name
    startRecordShow.value = true

    let channel = recorder.getChannelData();//获取左声道和右声道音频数据

}

//下载wav
const downWAV = () => {
    //这里传参进去的时文件名
    recorder.downloadWAV('新文件');
}
// 录音播放暂停录音播放
const playRecorder = () => {

    playOnoff.value = true
    playOnBtn.value = !playOnBtn.value
    if (!playOnBtn.value) {
        // 清除定时器
        clearInterval(reTimeSetvalRun)
        reTimeSetvalRun = null
        recorder.pausePlay()


    } else {
        recorder.play()//播放
        runPlayFn()
    }

}
// // 暂停录音播放
// const pausePlayRecorder = () => {
//     recorder.pausePlay()
// }
// 销毁录音
const destroyRecorder = () => {
    recorder.destroy().then((res) => {
        console.log(res)
        startRecordShow.value = true
        playOnoff.value = false
        lineStyle.value = initLine
        lineToLeft.value = 0
        lineStyle.value.forEach(item => {
            item.backgroundColor = '#585F66'
        })
        timeBoxLeft.value = 0
        runTime.value = 0
        lineIndex.value = 0
        reTimeStar.value = 0
        // recorder = null;
    })
}




const runPlayFn = () => {
    reTimeSetvalRun = setInterval(() => {
        // 387
        if (reTimeStar.value < runTime.value) {
            reTimeStar.value += 100
            if (lineToLeft.value <= 387) {
                lineStyle.value[lineIndex.value].backgroundColor = '#17B067'
                lineToLeft.value += 6
                lineIndex.value += 1
            } else {
                // lineStyle.value.push(lineStyle.value.shift())
                lineStyle.value.push(lineStyle.value.shift())
                lineStyle.value[lineIndex.value - 1].backgroundColor = '#17B067'
                lineStyle.value[lineStyle.value.length - 1].backgroundColor = '#585F66'
                // carveTimeScale(750, 1, 60, reTimeStar.value, 2, 'time_line')
                timeBoxLeft.value -= 6
                // console.log(lineStyle.shift())
            }
        } else if (reTimeStar.value == runTime.value) {
            playOnBtn.value = !playOnBtn.value
            clearInterval(reTimeSetvalRun)
            reTimeSetvalRun = null
            lineStyle.value = initLine
            lineToLeft.value = 0
            lineStyle.value.forEach(item => {
                item.backgroundColor = '#585F66'
            })
            timeBoxLeft.value = 0
            lineIndex.value = 0
            reTimeStar.value = 0
        }


    }, 100)
}
const token = Auth.getToken();
const filename=ref('')
const fileId=ref('')
const handleChange = () => {
    console.log(fileData.value)
    if(fileData.value==null || fileData.value==''){
        
        ElMessage({
            type: 'error',
            message: '请录制音频',
        })
        
        return
    }
    if(fileId.value!=''){
        emit('updataRecord',fileId.value)
        return
    }
    const formDatas = new FormData();
    formDatas.append('file',fileData.value);
    formDatas.append('businessType',props.businessType);
    formDatas.append('parentId',0);
    const option = {
        // host: FetchRequest.getHost(),
        method: 'post',
        headers: {
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + token,
        },
        data: {
            access_token: Auth.getToken(),
            name: "file",
        },
        body: formDatas
    };

    fetch(FetchRequest.getHost() + '/ai/voice/file/file', option)
        .then(function (response) {
            if (response.status == 200) {
                return response.json()
            }
        }).then(data=> {
            
            if (data.code == 200) {
                console.log(data)
                fileId.value=data.data.fileId
                emit('updataRecord',data.data.fileId)
                // upFileId.value=data.data.fileId
                // title.value=file.name
            } else {
                ElMessage({
                    type: 'error',
                    message: data.msg,
                })
            }
            

        })
    // const formDatas = new FormData();
    // formDatas.append('voiceFile', fileData.value);

    // roleAivoice.addvoice(0,fileData.value.name).then(res=>{
    //     console.log(res.data)
    //     let obj={
    //         state:0,
    //         voiceId:res.data,
    //         title:fileData.value.name,
    //         createTime:new Date().getTime(),
    //         progress:0,
    //     }
    // closePage()
    //     const taskId = res.data; // 生成唯一任务ID
    //     uploadFile(fileData.value, taskId);
    // })

    // const option = {
    //     // host: FetchRequest.getHost(),
    //     method: 'post',
    //     headers: {
    //         "Access-Control-Allow-Origin": "*",
    //         Authorization: "Bearer " + token,
    //     },
    //     data: {
    //         access_token: Auth.getToken(),
    //         name: "file",
    //     },
    //     body: formDatas
    // };
    // // console.log(FetchRequest.getHost())
    // fetch(FetchRequest.getHost() + '/vim/voice/change', option)
    //     .then(function (response) {
    //         console.log(response);
    //         if (response.status == 200) {
    //             // dialogVisible.value=false
    //             // emit('regetRole')
    //             return response.json()
    //         }
    //     }).then(function (data) {
    //         closePage()
    //         console.log(data);

    //     })
}



const dialogVisible = ref(true)
const startRecordShow = ref(true)
const lineToLeft = ref(0)
const lineIndex = ref(0)
const timeBoxLeft = ref(0)//时间轴偏移量
const audioRef = ref()
const playOnBtn = ref(false)//播放录音
nextTick(() => {
    for(let i=0;i<100;i++){
        carveTimeScale(1500, 1, 60, 25000*i, 2, 'time_line'+i)
    }
    
})
// 
const lineStyle = ref([])
const initLine = []
const linfHeight = [10, 30, 80, 160, 80, 40, 100, 60, 80, 60, 30, 10, 10, 40]
for (let i = 0; i < 135; i++) {
    const obj = {
        'height': linfHeight[i % 14] + 'px',
        'backgroundColor': '#585F66'
    }
    initLine.push(obj)
    lineStyle.value.push(obj)
}

const init = () => {
    dialogVisible.value = true
    lineStyle.value = initLine
    timeBoxLeft.value = 0
    lineToLeft.value = 0
    runTime.value = 0
    lineIndex.value = 0
    reTimeStar.value = 0

}



// 录音定时器
let reTimeSetval = null
const reTimeStar = ref(0)
// 录音组件
const audioBlobUrl = ref(null);
const isRecording = ref(false);
let mediaRecorder = null;
let audioChunks = [];
const fileData = ref()
const playOnoff = ref(false)
const startRecording = async () => {
    startRecordShow.value = false
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true }).catch((res) => {
        startRecordShow.value = true
        ElMessage({
            type: 'error',
            message: '不存在录音设备，或者被禁用--' + res,
        })
        return
    });
    mediaRecorder = new MediaRecorder(stream, { mimeType: 'audio/webm' })
    console.log(mediaRecorder)

    mediaRecorder.addEventListener('dataavailable', event => {
        if (event.data.size > 0) {
            audioChunks.push(event.data);


        }
    });

    mediaRecorder.addEventListener('stop', () => {
        // audio/wav audio/webm
        const audioBlob = new Blob(audioChunks, { type: 'audio/wav' });
        audioBlobUrl.value = URL.createObjectURL(audioBlob);
        let time = timedataOther(Date.now())
        fileData.value = new File([audioBlob], '录音' + time + '.wav');
        startRecordShow.value = true
        audioChunks = [];
    });

    mediaRecorder.start();
    reTimeSetval = setInterval(() => {
        // 387

        reTimeStar.value += 100

        if (lineToLeft.value <= 387) {
            lineStyle.value[lineIndex.value].backgroundColor = '#17B067'
            lineToLeft.value += 6
            lineIndex.value += 1
        } else {
            // lineStyle.value.push(lineStyle.value.shift())
            lineStyle.value.push(lineStyle.value.shift())
            lineStyle.value[lineIndex.value - 1].backgroundColor = '#17B067'
            lineStyle.value[lineStyle.value.length - 1].backgroundColor = '#fff'
            // carveTimeScale(750, 1, 60, reTimeStar.value, 2, 'time_line')
            timeBoxLeft.value -= 6
            // console.log(lineStyle.shift())
        }

    }, 100)
    startRecordShow.value = false
    // console.log('++++++++++++')
    isRecording.value = true;
};

const stopRecording = () => {
    // console.log('--------------')
    mediaRecorder.stop();
    startRecordShow.value = true
    playOnoff.value = true
    lineStyle.value = initLine
    lineToLeft.value = 0
    lineStyle.value.forEach(item => {
        item.backgroundColor = '#fff'
    })
    timeBoxLeft.value = 0
    runTime.value = 0
    lineIndex.value = 0
    reTimeStar.value = 0
    // 清除定时器
    clearInterval(reTimeSetval)
    reTimeSetval = null
    isRecording.value = false;
};

// 播放录音
let reTimeSetvalRun = null
const playBtn = () => {
    console.log(playOnBtn.value)
    playOnoff.value = true
    playOnBtn.value = !playOnBtn.value
    if (!playOnBtn.value) {
        // 清除定时器
        clearInterval(reTimeSetvalRun)
        reTimeSetvalRun = null
        audioRef.value.pause()

    } else {
        audioRef.value.play()//播放
        runPlayFn()
    }
}
// 录音播放进度
const runTime = ref(0)

// 录音播放时间
const updateCurrentTime = (e: any) => {
    // console.log(e.target.currentTime)
    // 音频播放完后暂停
    if (e.target.currentTime >= audioRef.value.duration) {
        clearInterval(reTimeSetvalRun)
        reTimeSetvalRun = null
        playOnBtn.value = false
        lineStyle.value = initLine
        lineToLeft.value = 0
        lineStyle.value.forEach(item => {
            item.backgroundColor = '#fff'
        })
        timeBoxLeft.value = 0
        runTime.value = 0
        lineIndex.value = 0
        reTimeStar.value = 0
    }
}
// 关闭页面  defineEmits
const emit = __emit
const closePage = () => {
    dialogVisible.value = false
    emit('closePage')
}
// 重新录音
const changeRecord = () => {
    console.log('重新录音')
    // startRecordShow&&!playOnoff
    fileId.value=''
    titleName.value=''
    startRecordShow.value = true
    playOnoff.value = false
    lineStyle.value = initLine
    lineToLeft.value = 0
    lineStyle.value.forEach(item => {
        item.backgroundColor = '#fff'
    })
    timeBoxLeft.value = 0
    runTime.value = 0
    lineIndex.value = 0
    reTimeStar.value = 0


}
const updataRecording=()=>{
    handleChange()
}
const updataRecordingListening=()=>{
    if(fileData.value==null || fileData.value==''){
        
        ElMessage({
            type: 'error',
            message: '请录制音频',
        })
        
        return
    }
    const formDatas = new FormData();
    formDatas.append('file',fileData.value);
    formDatas.append('businessType',props.businessType);
    formDatas.append('parentId',0);
    const option = {
        // host: FetchRequest.getHost(),
        method: 'post',
        headers: {
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + token,
        },
        data: {
            access_token: Auth.getToken(),
            name: "file",
        },
        body: formDatas
    };

    fetch(FetchRequest.getHost() + '/ai/voice/file/file', option)
        .then(function (response) {
            if (response.status == 200) {
                return response.json()
            }
        }).then(data=> {
            
            if (data.code == 200) {
                console.log(data)
                emit('updataListening',data.data.url)
                // upFileId.value=data.data.fileId
                // title.value=file.name
            } else {
                ElMessage({
                    type: 'error',
                    message: data.msg,
                })
            }
            

        })
}
__expose({
    init,
    updataRecording,
    updataRecordingListening,
})

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(titleName.value), 1),
      (playOnoff.value)
        ? (_openBlock(), _createBlock(_component_el_icon, {
            key: 0,
            class: "reClickRecord",
            color: "#5E5F65",
            size: "22",
            onClick: changeRecord
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(CircleCloseFilled))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(timeInfominute)(reTimeStar.value)), 1),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: "recordBoxTimeBox",
              style: _normalizeStyle({ 'left': timeBoxLeft.value + 'px' })
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(100, (item, index) => {
                return _createElementVNode("canvas", {
                  id: 'time_line'+index,
                  width: "1500",
                  height: "30",
                  key: index
                }, null, 8, _hoisted_9)
              }), 64))
            ], 4)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lineStyle.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "recordBoxRunInnerOne",
                  style: _normalizeStyle({ 'height': item.height, 'backgroundColor': item.backgroundColor })
                }, null, 4))
              }), 128))
            ])
          ]),
          _createElementVNode("div", {
            class: "timeLine",
            style: _normalizeStyle({ 'left': lineToLeft.value - 4 + 'px' })
          }, _cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "timeBlock" }, [
              _createElementVNode("div", { class: "square" }),
              _createElementVNode("div", { class: "arrow" }),
              _createElementVNode("div", { class: "line" })
            ], -1)
          ]), 4)
        ]),
        _createElementVNode("div", _hoisted_12, [
          (startRecordShow.value && !playOnoff.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "recordBtnOne",
                onClick: startRecorder
              }, _cache[1] || (_cache[1] = [
                _createElementVNode("img", {
                  src: _imports_0,
                  class: "recordBtnOneBtn"
                }, null, -1),
                _createElementVNode("span", null, "开始录音", -1)
              ])))
            : _createCommentVNode("", true),
          (!startRecordShow.value && !playOnoff.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "recordBtnOne",
                onClick: stopRecorder
              }, _cache[2] || (_cache[2] = [
                _createElementVNode("img", {
                  src: _imports_1,
                  class: "recordBtnOneBtn"
                }, null, -1),
                _createElementVNode("span", null, "结束录音", -1)
              ])))
            : _createCommentVNode("", true),
          (playOnoff.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (!playOnBtn.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _imports_2,
                      onClick: playRecorder
                    }))
                  : _createCommentVNode("", true),
                (playOnBtn.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: _imports_3,
                      onClick: playRecorder
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (audioBlobUrl.value)
        ? (_openBlock(), _createElementBlock("audio", {
            key: 0,
            src: audioBlobUrl.value,
            controls: "",
            onTimeupdate: updateCurrentTime,
            style: {"display":"none"},
            ref_key: "audioRef",
            ref: audioRef
          }, null, 40, _hoisted_14))
        : _createCommentVNode("", true)
    ]),
    (playOnoff.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15))
      : _createCommentVNode("", true)
  ]))
}
}

})